import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import NoteEditor from 'components/shared/NoteEditor';
import {
  getCurrentClient,
  noteEditorSelector,
} from 'selectors/admin/clients/clients';
import {
  setNoteEditorEdit,
  updateNotes,
  updateNoteEditorText,
  updateNoteEditorReminder,
} from 'actions/admin/clients/clients';

class ClientDetailsNoteEditor extends Component {
  static propTypes = {
    currentClient: PropTypes.shape({}).isRequired,
    noteEditor: PropTypes.shape({
      edit: PropTypes.bool.isRequired,
      reminder: PropTypes.string,
      saving: PropTypes.bool.isRequired,
      text: PropTypes.string.isRequired,
    }).isRequired,
    onEdit: PropTypes.func.isRequired,
    onNoteReminderChange: PropTypes.func.isRequired,
    onNoteTextChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
  };

  handleSave = () => {
    const { currentClient, noteEditor, onSave } = this.props;
    onSave(currentClient.id, noteEditor.text, noteEditor.reminder);
  };

  render() {
    const {
      currentClient,
      noteEditor,
      onEdit,
      onNoteReminderChange,
      onNoteTextChange,
    } = this.props;
    return (
      <NoteEditor
        editButtonLabel="Edit Note"
        edit={noteEditor.edit}
        label="notes"
        lines={4}
        reminderLabel="reminder date"
        reminderValue={noteEditor.reminder}
        reminderOriginalValue={currentClient.note_reminder_date}
        saving={noteEditor.saving}
        value={noteEditor.text}
        onEdit={onEdit}
        onReminderValueChange={onNoteReminderChange}
        onSave={this.handleSave}
        onValueChange={onNoteTextChange}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentClient: getCurrentClient(state),
    noteEditor: noteEditorSelector(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onEdit: () => {
    dispatch(setNoteEditorEdit(true));
    dispatch(updateNoteEditorReminder(null));
  },
  onNoteReminderChange: (value) => {
    dispatch(updateNoteEditorReminder(value));
  },
  onNoteTextChange: (value) => {
    dispatch(updateNoteEditorText(value));
  },
  onSave: (clientId, text, reminder) => {
    dispatch(updateNotes(clientId, text, reminder));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientDetailsNoteEditor);



// WEBPACK FOOTER //
// ./src/components/admin/clients/ClientDetailsNoteEditor.js